import * as React from 'react';

import { ModalWindow } from '@cian/ui-kit';
import { TButtonTheme } from '@cian/ui-kit/button/types';

import { AboutRealtorFooter } from '../../components/AboutRealtorFooter';
import { RealtorInfoContainer } from '../RealtorInfoContainer';
import { ISpecialistCatalogListingSchema } from '../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';
import { ErrorModal } from '../../components/ErrorModal';
import { IRealtorData } from '../../types/realtorInfo';
import { ModalLoader } from '../../components/ModalLoader';

export interface IAboutRealtorModalContainerProps {
  resetRealtorCardData: () => void;
  handleSelectRealtor: (realtor?: ISpecialistCatalogListingSchema | null) => void;
  handleUnselectRealtor: (realtorId?: string) => void;
  realtor?: ISpecialistCatalogListingSchema | null;
  realtorCardData: IRealtorData | null;
  isRealtorCardDataError: boolean;
  isRealtorCardDataFetching: boolean;
  isSelectedRealtor: boolean;
  isButtonDisabled: boolean;
}

export const AboutRealtorModalContainer: React.FC<
  React.PropsWithChildren<IAboutRealtorModalContainerProps>
> = props => {
  const {
    realtor,
    realtorCardData,
    isRealtorCardDataError,
    isRealtorCardDataFetching,
    isSelectedRealtor,
    isButtonDisabled,
    handleSelectRealtor,
    handleUnselectRealtor,
    resetRealtorCardData,
  } = props;

  const onSelectInModal = (realtor?: ISpecialistCatalogListingSchema | null) => {
    handleSelectRealtor(realtor);
    resetRealtorCardData();
  };

  const onUnselectInModal = (realtor?: ISpecialistCatalogListingSchema | null) => {
    handleUnselectRealtor(String(realtor?.id));
    resetRealtorCardData();
  };

  const buttonProps = isSelectedRealtor
    ? {
        buttonText: 'Отменить выбор',
        buttonTheme: 'fill_white_primary' as TButtonTheme,
        onButtonClick: () => onUnselectInModal(realtor),
      }
    : {
        buttonText: 'Выбрать',
        buttonTheme: 'fill_secondary' as TButtonTheme,
        onButtonClick: () => onSelectInModal(realtor),
      };

  switch (true) {
    case Boolean(realtorCardData && realtor): {
      return (
        <ModalWindow
          fixed={true}
          open={true}
          onClose={resetRealtorCardData}
          width={980}
          height={'100%'}
          maxHeight={708}
          content={<RealtorInfoContainer />}
          footer={<AboutRealtorFooter {...buttonProps} isButtonDisabled={isButtonDisabled} />}
        />
      );
    }
    case isRealtorCardDataFetching: {
      return (
        <ModalWindow
          fixed={true}
          open={true}
          onClose={resetRealtorCardData}
          width={980}
          height={'100%'}
          maxHeight={708}
          content={<ModalLoader />}
        />
      );
    }
    case isRealtorCardDataError: {
      return <ErrorModal open={true} onClose={resetRealtorCardData} />;
    }
    default:
      return null;
  }
};

AboutRealtorModalContainer.displayName = 'AboutRealtorModalContainer';
